import { FC, Fragment } from 'react';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';
import CountUp from 'react-countup';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';

const FRMThingsToDo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	const data = [
		{
			title: 'Customer Checking',
			count: counts?.customerChecking ?? 0,
			link: 'FRMCustomerCheckingListPage',
		},
		{
			title: 'Data Pra-Survey',
			count: counts?.praSurvey ?? 0,
			link: 'FRMPraSurveyPage',
		},
		{
			title: 'Request Survey',
			count: counts?.requestSurvey ?? 0,
			link: 'FRMRequestSurveyPage',
		},
		{
			title: 'Laporan Kunjungan',
			count: counts?.visitReport ?? 0,
			link: 'FRMVisitReportListPage',
		},
		{
			title: 'Pipeline Hot Prospect',
			count: counts?.pipelineHotProspect ?? 0,
			link: 'FRMPipelineListPage',
		},
		{
			title: 'Pipeline Golive',
			count: counts?.pipelineGoLive ?? 0,
			link: 'GoliveListPage',
		},
		{
			title: 'Nota Analisa Pembiayaan',
			count: counts?.nap ?? 0,
			link: 'NAPListPage',
		},
		{
			title: 'Pemberitahuan Fasilitas',
			count: counts?.spf ?? 0,
			link: 'SPFListPage',
		},
		{
			title: 'Simulasi Kredit',
			count: counts?.creditSimulation ?? 0,
			link: 'FRMSimulationListPage',
		},
		{
			title: 'Memo Pencairan Pembiayaan',
			count: counts?.mpp ?? 0,
			link: 'MPPListPage',
		},
		{
			title: 'Purchase Order',
			count: counts?.purchaseOrder ?? 0,
			link: 'FRMPOListPage',
		},
	];

	return (
		<Fragment>
			<List
				loading={isLoading}
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default FRMThingsToDo;
